import type { DocMigration } from "../docMigration";

const wallMaterialIdFromLumberProfile = {
  SPF_2X4: "defaultStructuralMaterial2X4",
  SPF_2X4_SHEATHING_HALF: "defaultStructuralMaterial2X4a",
  SPF_2X4_SHEATHING_1: "defaultStructuralMaterial2X4b",
  SPF_2X6: "defaultStructuralMaterial2X6",
  SPF_2X6_SHEATHING_HALF: "defaultStructuralMaterial2X6a",
  SPF_2X6_SHEATHING_1: "defaultStructuralMaterial2X6b",
  SPF_2X8: "defaultStructuralMaterial2X8",
  SPF_2X10: "defaultStructuralMaterial2X10",
  SPF_2X12: "defaultStructuralMaterial2X12",
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_120: DocMigration = {
  maxSchemaVersion: "0.0.120",
  description: "Custom structural materials",
  apply(json: any) {
    const allSettings = json.settings;

    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "WALL_CATALOG_SETTINGS") {
        continue;
      }

      const { wallTypes } = settings;

      if (wallTypes) {
        for (const wallTypeId in wallTypes) {
          const wallType = wallTypes[wallTypeId];

          wallType.structuralMaterialId = wallMaterialIdFromLumberProfile[wallType.lumberProfile];
          delete wallType.lumberProfile;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_120;
